import { withInstall } from '@zoryn/utils'
import ColorPickerPanel from './src/color-picker-panel.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZColorPickerPanel: SFCWithInstall<typeof ColorPickerPanel> =
  withInstall(ColorPickerPanel)
export default ZColorPickerPanel

export * from './src/color-picker-panel'
